<div class="upload-dialog-container">

    <!-- Header -->
    <div class="dialog-header">
        <h2>{{data?.title || 'Select Image'}}</h2>
        <div class="header-actions">
            <!-- Resource Type Selection -->
            <button mat-icon-button (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Content Area -->
    <div class="dialog-content">
        <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex" mat-align-tabs="start">

            <!-- TAB 1: Upload Files -->
            <mat-tab label="Upload Files">
                <div class="tab-content-wrapper">
                    <div class="media-toolbar">
                        <div class="toolbar-left">
                            <select class="form-select w-auto" name="ResourceType"
                                (ngModelChange)="onResourceTypeChange($event)" [(ngModel)]="resource_type_id"
                                *ngIf="resource_types?.length > 0">
                                <option [ngValue]="0" disabled>-- Select Resource Type --</option>
                                <option *ngFor="let type of resource_types" [ngValue]="type.resource_type_id">
                                    {{type.resource_type_name}}
                                </option>
                            </select>
                            <select class="form-select w-auto" name="Language"
                                (change)="getLanguageID($event.target.value)" [(ngModel)]="language_id">
                                <option [ngValue]="0" disabled>-- Select Language --</option>
                                <option *ngFor="let lang of language" [ngValue]="lang.language_id">
                                    {{lang.language_name}}
                                </option>
                            </select>
                        </div>

                        <div class="toolbar-right">

                        </div>
                    </div>

                    <!-- Upload Zone -->
                    <div class="row" style="padding: 15px;" *ngIf="!imageChangedEvent && !croppedImage">
                        <div class="col-12">
                            <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)"
                                (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" class="w-100">
                                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                    <div class="upload-zone d-flex flex-column align-items-center justify-content-center w-100 mb-0 pointer rounded bg-light border border-secondary border-dashed"
                                        style="min-height: 250px; border-style: dashed !important; margin-top: 240px !important;"
                                        (click)="openFileSelector()">
                                        <mat-icon class="display-3 text-secondary mb-3"
                                            style="width: auto; height: auto; font-size: 3rem;">cloud_upload</mat-icon>
                                        <h3 class="h4 text-dark font-weight-bold">Drop files to upload</h3>
                                        <p class="text-secondary mb-3">or click to select</p>
                                        <button mat-raised-button color="primary" class="px-4 py-1" type="button">Select
                                            Files</button>
                                        <div class="mt-3 text-muted small">Max size: 2MB | {{Width}}px x {{Height}}px
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-file-drop>
                        </div>
                    </div>

                    <!-- Cropper Zone -->
                    <div class="row justify-content-center" style="padding: 15px;"
                        *ngIf="imageChangedEvent || croppedImage">
                        <div class="col-12">
                            <div class="cropper-container">
                                <div class="cropper-wrapper">
                                    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                                        [aspectRatio]="aspectRatio" [cropperMinWidth]="128" [onlyScaleDown]="true"
                                        [roundCropper]="false" [canvasRotation]="canvasRotation"
                                        [(transform)]="transform" [alignImage]="'center'"
                                        [style.display]="showCropper ? null : 'none'" format="webp"
                                        (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                                        (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()">
                                    </image-cropper>
                                    <div *ngIf="loading" class="loader"><mat-spinner diameter="40"></mat-spinner></div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center mt-3">
                            <div *ngIf="+filesize > 2048" class="text-danger">
                                File size exceeds limit (2MB).
                            </div>
                            <div class="text-muted">
                                {{Width}} x {{Height}} px | {{filesize || 0}} KB
                            </div>
                        </div>
                    </div>

                </div>
            </mat-tab>

            <!-- TAB 2: Media Library -->
            <mat-tab label="Media Library">
                <div class="tab-content-wrapper">
                    <!-- Toolbar -->
                    <div class="media-toolbar">
                        <div class="toolbar-left">
                            <select class="form-select w-auto" name="ResourceType"
                                (ngModelChange)="onResourceTypeChange($event)" [(ngModel)]="resource_type_id"
                                *ngIf="resource_types?.length > 0">
                                <option [ngValue]="0" disabled>-- Select Resource Type --</option>
                                <option *ngFor="let type of resource_types" [ngValue]="type.resource_type_id">
                                    {{type.resource_type_name}}
                                </option>
                            </select>
                            <select class="form-select w-auto" name="Language"
                                (change)="getLanguageID($event.target.value)" [(ngModel)]="language_id">
                                <option [ngValue]="0" disabled>-- Select Language --</option>
                                <option *ngFor="let lang of language" [ngValue]="lang.language_id">
                                    {{lang.language_name}}
                                </option>
                            </select>
                        </div>

                        <div class="toolbar-right">
                            <div class="search-box">
                                <mat-icon>search</mat-icon>
                                <input type="text" [(ngModel)]="searchText" placeholder="Search"
                                    (keyup.enter)="getImages()">
                            </div>

                            <div class="view-switch">
                                <button [class.active]="viewMode === 'grid'" (click)="viewMode = 'grid'">
                                    <mat-icon>grid_view</mat-icon>
                                </button>
                                <button [class.active]="viewMode === 'list'" (click)="viewMode = 'list'">
                                    <mat-icon>view_list</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Scrollable Area -->
                    <div class="media-scroll-area">
                        <!-- Loader -->
                        <div *ngIf="visibleloader || medialoader" class="text-center p-5">
                            <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
                        </div>

                        <!-- Grid View -->
                        <div class="media-grid-view" *ngIf="!visibleloader && viewMode === 'grid'">
                            <div class="media-item"
                                *ngFor="let image of images | paginate: { id: 'upload_pagination', itemsPerPage: count, currentPage: page, totalItems: rowCount}"
                                [class.selected]="isSelected(image)"
                                (click)="addToSelectedIMG(image, !isSelected(image))">

                                <div class="media-img-wrapper">
                                    <img [src]="image.Medium" onerror="this.src='assets/images/icons/small_no_img.png'">
                                    <div class="check-overlay"><mat-icon>check</mat-icon></div>
                                </div>

                                <div class="media-info">
                                    <div class="filename" title="{{image.original_filename}}">
                                        {{image.original_filename}}</div>
                                    <button mat-icon-button color="warn" class="delete-btn"
                                        (click)="$event.stopPropagation(); deleteResource(image.resource_id)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- List View -->
                        <div class="media-list-view" *ngIf="!visibleloader && viewMode === 'list'">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="50"></th>
                                        <th>File</th>
                                        <th>Date</th>
                                        <th width="50"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let image of images | paginate: { id: 'upload_pagination', itemsPerPage: count, currentPage: page, totalItems: rowCount}"
                                        [class.selected]="isSelected(image)"
                                        (click)="addToSelectedIMG(image, !isSelected(image))">
                                        <td>
                                            <img [src]="image.Medium" class="img-preview"
                                                onerror="this.src='assets/images/icons/small_no_img.png'">
                                        </td>
                                        <td>{{image.original_filename}}</td>
                                        <td>{{ image.created_at | date:'shortDate' }}</td>
                                        <td>
                                            <button mat-icon-button color="warn"
                                                (click)="$event.stopPropagation(); deleteResource(image.resource_id)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> <!-- End Scroll Area -->

                    <!-- Internal Footer for Pagination -->
                    <!-- Note: This footer sits INSIDE the tab wrapper, above the main dialog footer -->
                    <div class="dialog-footer media-pagination-footer" *ngIf="!visibleloader">
                        <div class="footer-left">
                            <span *ngIf="rowCount > 0">{{rowCount}} items</span>
                        </div>
                        <div class="footer-right">
                            <!-- Items Per Page -->
                            <select class="form-select w-auto me-3" [(ngModel)]="count"
                                (change)="changeCount($event.target.value)">
                                <option *ngFor="let c of counts" [value]="c">{{c}} per page</option>
                            </select>

                            <div class="pagination-controls">
                                <button [disabled]="page <= 1" (click)="onPageChanged(1)">«</button>
                                <button [disabled]="page <= 1" (click)="onPageChanged(page - 1)">‹</button>

                                <span>Page</span>
                                <input type="number" class="current-page-input" [(ngModel)]="page"
                                    (keydown.enter)="onPageChanged(page)" (blur)="onPageChanged(page)" min="1"
                                    [max]="rowCount">
                                <span>of {{ (rowCount / count) | number:'1.0-0' }}</span>

                                <button [disabled]="page * count >= rowCount"
                                    (click)="onPageChanged(page + 1)">›</button>
                                <button [disabled]="page * count >= rowCount"
                                    (click)="onPageChanged(rowCount)">»</button>
                            </div>
                        </div>
                    </div>

                </div>
            </mat-tab>
        </mat-tab-group>
    </div>


    <!-- Footer Actions (Main Dialog) -->
    <div class="dialog-footer">
        <div class="selected-count" *ngIf="selectedTabIndex === 1 && appService.Data.selectedIMG.length > 0">
            Selected: <span>{{appService.Data.selectedIMG.length}} item(s)</span>
        </div>

        <!-- Push buttons to right -->
        <div style="flex: 1;"></div>

        <button mat-button (click)="closeDialog()">Close</button>

        <!-- Upload Tab Actions -->
        <ng-container *ngIf="selectedTabIndex === 0">
            <button mat-button color="warn" *ngIf="croppedImage"
                (click)="imageChangedEvent = ''; croppedImage = ''">Reset</button>
            <button mat-raised-button color="primary" *ngIf="croppedImage" (click)="uploadCroppedFiles()"
                [disabled]="!croppedImage || +filesize > 2048">
                Upload
            </button>
        </ng-container>

        <!-- Library Tab Actions -->
        <ng-container *ngIf="selectedTabIndex === 1">
            <button mat-raised-button color="primary" [disabled]="appService.Data.selectedIMG.length === 0"
                (click)="addImage()">
                Insert Media
            </button>
        </ng-container>
    </div>
</div>